import { render } from "./AddObject.vue?vue&type=template&id=d1f7a1f4"
import script from "./AddObject.vue?vue&type=script&lang=js"
export * from "./AddObject.vue?vue&type=script&lang=js"

import "./AddObject.vue?vue&type=style&index=0&id=d1f7a1f4&lang=scss"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__